module.exports = __webpack_public_path__ + "static/media/c1.d8c54ae2.jpg";